import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ActivityTemplateInterface } from "../../Entity/Entities/Activity/ActivityTemplateInterface";
import ActivityTemplateFactory from "../../Entity/Factories/ActivityTemplateFactory";
import Translator from "../../Translation/Translator";

export default function* activityTemplateCreate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_CREATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_CREATE_REQUEST
    });

    const res = yield call(Http.post, `activity-templates`, {
      name: action.payload?.name,
      taskTemplates: action.payload?.taskTemplates
    });

    const activityTemplate: ActivityTemplateInterface = ActivityTemplateFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_CREATE_SUCCESS,
      payload: {
        activityTemplate: activityTemplate
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-activity-template-created-successfully"),
        type: "success"
      }
    });

    const receivedTaskTemplates = res?.data?.data?.taskTemplates || [];

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, activityTemplate, [...receivedTaskTemplates]);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchActivityTemplateCreate() {
  yield takeEvery(Constants.GLOBAL_ACTIVITY_TEMPLATE_CREATE_START, activityTemplateCreate);
}
